import axios from 'axios';

function paginacao(lista = [], itensPorPagina, paginaAtual){
    let indiceInicial = 0;
    let indiceFinal = itensPorPagina;
    
    const paginas = Math.ceil(lista.length / itensPorPagina);

    if(lista.length > itensPorPagina){
        indiceInicial = (paginaAtual * itensPorPagina);
        indiceFinal = (indiceInicial + itensPorPagina);
    }

    const listaAtual = lista.slice(indiceInicial, indiceFinal);

    return {
        paginas: paginas,
        lista: listaAtual
    };
}

function gerarBotoes(paginaAtual, totalPaginas){
    const botoes = [];

    if (totalPaginas <= 5) {
        // Caso poucas páginas, mostra tudo
        for (let i = 0; i < totalPaginas; i++) {
            botoes.push(i);
        }
    } else {
        // Sempre mostrar: primeira, última, atual e vizinhos
        botoes.push(0);

        const inicio = Math.max(1, paginaAtual - 1);
        const fim = Math.min(totalPaginas - 2, paginaAtual + 1);

        if (inicio > 1) botoes.push('...');

        for (let i = inicio; i <= fim; i++) {
            botoes.push(i);
        }
        
        if (fim < totalPaginas - 2) botoes.push('...');

        botoes.push(totalPaginas - 1);
    }

    return botoes;
};

function dateFormat(date){
    const inputValue = date;

    // Remova caracteres não numéricos
    const numericValue = inputValue.replace(/\D/g, '');

    // Limite a 10 caracteres
    const limitedValue = numericValue.slice(0, 8);
    let formattedValue = limitedValue;

    if(limitedValue.length <= 2){
        formattedValue = limitedValue.slice(0, 2);   
    }

    if(limitedValue.length == 3){
        formattedValue = limitedValue.slice(0, 2) + '/' + limitedValue.slice(2, 3);   
    }

    if(limitedValue.length == 4){
        formattedValue = limitedValue.slice(0, 2) + '/' + limitedValue.slice(2, 4);   
    }
    
    if(limitedValue.length >= 5){
        formattedValue = limitedValue.slice(0, 2) + '/' + limitedValue.slice(2, 4) + '/' + limitedValue.slice(4, 8);   
    }

    return formattedValue;
}

function somenteNumeros(inputValue, max){
    return inputValue.replace(/\D/g, '').slice(0, max);
}

function maxLenght(inputValue, max){
    return inputValue.slice(0, max);
}

function mascaraValor(inputValue, limitInput){
    // Remova caracteres não numéricos
    const numericValue = inputValue.replace(/\D/g, '');

    // Limite a 10 caracteres
    const limitedValue = numericValue.slice(0, limitInput);
    let formattedValue = limitedValue;

    for(let i = 1; i <= limitInput; i++){
        if(limitedValue.length == i && i == 2){
            formattedValue = limitedValue.slice(((i - i)), (i - 1)) + ',' + limitedValue.slice((i - 1), i);
        }

        if(limitedValue.length == i && (i > 2 && i <= 5)){
            formattedValue = limitedValue.slice(((i - i)), (i - 2)) + ',' + limitedValue.slice((i - 2), i);
        }

        if(limitedValue.length == i && (i > 5 && i <= limitInput)){
            formattedValue = limitedValue.slice(((i - i)), (i - 5)) + '.' + limitedValue.slice(((i - 5)), (i - 2)) + ',' + limitedValue.slice((i - 2), i);
        }
    }

    return formattedValue;
}

function mascaraPorcentagem(inputValue){
    let formattedValue = inputValue.includes(',') ? inputValue.replace(',', '.') : inputValue;
    const explode = formattedValue.includes('.') && formattedValue.split('.');

    if(formattedValue > 100.00000){
        return '100.00000';
    }

    if(explode.length > 0){
        if(explode[1] !== undefined){
            formattedValue = `${explode[0].slice(0,3)}.${explode[1].slice(0,5)}`;
        }else{
            formattedValue = `${explode[0].slice(0,3)}}`;
        }
    }

    return formattedValue;
}

function mascaraCpfCnpj(inputValue = '', tpPessoa = null) {
    const digits = (inputValue || '').toString().replace(/\D/g, '');

    if (!tpPessoa) {
        // se não souber o tipo, tenta formatar conforme o tamanho
        if (digits.length <= 11) tpPessoa = 'F';
        else tpPessoa = 'J';
    }

    if (tpPessoa === 'F') {
        // CPF: 000.000.000-00
        const p1 = digits.slice(0, 3);
        const p2 = digits.slice(3, 6);
        const p3 = digits.slice(6, 9);
        const p4 = digits.slice(9, 11);
        let out = p1;
        if (p2) out += '.' + p2;
        if (p3) out += '.' + p3;
        if (p4) out += '-' + p4;
        return out;
    }

    // PJ: 00.000.000/0000-00
    if (tpPessoa === 'J') {
        const p1 = digits.slice(0, 2);
        const p2 = digits.slice(2, 5);
        const p3 = digits.slice(5, 8);
        const p4 = digits.slice(8, 12);
        const p5 = digits.slice(12, 14);
        let out = p1;
        if (p2) out += '.' + p2;
        if (p3) out += '.' + p3;
        if (p4) out += '/' + p4;
        if (p5) out += '-' + p5;
        return out;
    }

    return inputValue;
}

function mascaraTelefones(inputValue){
    // Remova caracteres não numéricos
    const numericValue = inputValue.replace(/\D/g, '');
    const limitedValue = numericValue.slice(0, 11);
    let formattedValue = limitedValue;

    if(limitedValue.length == 10){
        formattedValue = '(' + limitedValue.slice(0, 2) + ') ' + limitedValue.slice(2, 6) + '-' + limitedValue.slice(6, 10);
    }

    if(limitedValue.length == 11){
        formattedValue = '(' + limitedValue.slice(0, 2) + ') ' + limitedValue.slice(2, 7) + '-' + limitedValue.slice(7, 11);
    }

    return formattedValue;
}

function mascaraCep(inputValue){
    // Remova caracteres não numéricos
    const numericValue = inputValue.replace(/\D/g, '');

    const limitedValue = numericValue.slice(0, 8);
    let formattedValue = limitedValue;

    if(limitedValue.length >= 1 && limitedValue.length <= 5){
        formattedValue = `${limitedValue.slice(0, 2)}.${limitedValue.slice(2, 5)}`;
    }

    if(limitedValue.length > 5 && limitedValue.length <= 8){
        formattedValue = `${limitedValue.slice(0, 2)}.${limitedValue.slice(2, 5)}-${limitedValue.slice(5, 8)}`;
    }

    return formattedValue;
}

function mascaraDDD(inputValue){
    // Remova caracteres não numéricos
    const numericValue = inputValue.replace(/\D/g, '');
    const limitedValue = numericValue.slice(0, 2);

    return limitedValue;
}

function mascaraNbm(inputValue){
    // Remova caracteres não numéricos
    const numericValue = inputValue.replace(/\D/g, '');

    const limitedValue = numericValue.slice(0, 10);
    let formattedValue = limitedValue;

    if(limitedValue.length == 8){
        formattedValue = limitedValue.slice(0, 4)+'.'+limitedValue.slice(4, 6)+'.'+limitedValue.slice(6, 8);
    }

    if(limitedValue.length == 10){
        formattedValue = limitedValue.slice(0, 4)+'.'+limitedValue.slice(4, 6)+'.'+limitedValue.slice(6, 10);
    }

    return formattedValue;
}

function mascaraNCm(inputValue){
    // Remova caracteres não numéricos
    const numericValue = inputValue.replace(/\D/g, '');

    const limitedValue = numericValue.slice(0, 8);
    let formattedValue = limitedValue;

    if(limitedValue.length == 8){
        formattedValue = limitedValue.slice(0, 4)+'.'+limitedValue.slice(4, 6)+'.'+limitedValue.slice(6, 8);
    }

    return formattedValue;
}

function validarEmail(inputValue){
    const regex = /@/;
    return regex.test(inputValue);
}

function mascaraHorario(inputValue, max){
    // Remova caracteres não numéricos
    const numericValue = inputValue.replace(/\D/g, '');
    const limitedValue = numericValue.slice(0, max);
    let formattedValue = limitedValue;

    if(limitedValue.length == 4){
        formattedValue = limitedValue.slice(0, 2) + ':' + limitedValue.slice(2, 4);
    }
    
    if(limitedValue.length == 6){
        formattedValue = limitedValue.slice(0, 2) + ':' + limitedValue.slice(2, 4) + ':' + limitedValue.slice(4, 6);
    }

    return formattedValue;
}

function formataValorPtBr(input){
    if(!input) return 0;
    return input.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function validadorCpfCnpj(valor) {
    const v = (valor || '').replace(/\D+/g, '');

    // ----- CPF -----
    if (v.length === 11) {
        if (/^(\d)\1+$/.test(v)) return false;

        let soma = 0;
        for (let i = 0; i < 9; i++) soma += v[i] * (10 - i);
        let d1 = soma % 11;
        d1 = d1 < 2 ? 0 : 11 - d1;
        if (+v[9] !== d1) return false;

        soma = 0;
        for (let i = 0; i < 10; i++) soma += v[i] * (11 - i);
        let d2 = soma % 11;
        d2 = d2 < 2 ? 0 : 11 - d2;
        return +v[10] === d2;
    }

    // ----- CNPJ -----
    if (v.length === 14) {
        if (/^(\d)\1+$/.test(v)) return false;

        const calc = (base, pesos) => {
            let soma = 0;
            for (let i = 0; i < pesos.length; i++) {
                soma += base[i] * pesos[i];
            }
            const r = soma % 11;
            return r < 2 ? 0 : 11 - r;
        };

        const nums = v.split('').map(Number);

        const d1 = calc(nums.slice(0, 12), [5,4,3,2,9,8,7,6,5,4,3,2]);
        if (nums[12] !== d1) return false;

        const d2 = calc(nums.slice(0, 13), [6,5,4,3,2,9,8,7,6,5,4,3,2]);
        return nums[13] === d2;
    }

    return false;
}

function tirarAcentos(str) {
  return str
    .normalize("NFD")                   // separa acentos
    .replace(/[\u0300-\u036f]/g, "");   // remove acentos
}

function sanitizeQuantidade(value, usarInputFloat, ctrEstoqueProdutoWeb, qtProdutoDisponivel) {
    // ------------------------
    // CALCULAR ESTOQUE DISPONÍVEL (igual ao seu código original)
    // ------------------------
    let qtDisponivel = usarInputFloat ? 999.999 : 999;

    if (!ctrEstoqueProdutoWeb && Number(qtProdutoDisponivel) > 0) {
        qtDisponivel = Number(qtProdutoDisponivel);
    }

    // ------------------------
    // FLOAT MODE
    // ------------------------
    if (usarInputFloat) {
        let raw = value.replace(/[^0-9.,]/g, '').replace(',', '.');

        if (raw === '') return { raw: '', numeric: null };
        if (raw === '.') return { raw: '0.', numeric: null };

        // permitir apenas 1 ponto
        const parts = raw.split('.');
        if (parts.length > 2) {
            raw = parts[0] + '.' + parts.slice(1).join('');
        }

        // limitar casas
        if (raw.includes('.')) {
            const [i, d] = raw.split('.');
            raw = i.slice(0, 3) + '.' + (d ?? '').slice(0, 3);
        } else {
            raw = raw.slice(0, 3);
        }

        const numeric = Number(raw);

        // permitido intermediário
        if (isNaN(numeric)) return { raw, numeric: null };

        // ------------------------
        // limite mínimo
        // ------------------------
        if (numeric > 0 && numeric < 0.100) {
            return { raw: '0.100', numeric: 0.100 };
        }

        // ------------------------
        // ESTOQUE <= 0 → DIGITAÇÃO LIVRE
        // ------------------------
        if (Number(qtProdutoDisponivel) <= 0) {
            if (numeric > 999.999)
                return { raw: '999.999', numeric: 999.999 };
            return { raw, numeric };
        }

        // ------------------------
        // ESTOQUE > 0 → LIMITAR AO ESTOQUE
        // ------------------------
        if (numeric > qtDisponivel) {
            return { raw: String(qtDisponivel), numeric: qtDisponivel };
        }

        return { raw, numeric };
    }

    // ------------------------
    // INTEGER MODE
    // ------------------------
    let raw = value.replace(/[^0-9]/g, '').slice(0, 3);

    if (raw === '') return { raw: '', numeric: null };

    const numeric = Number(raw);
    if (isNaN(numeric)) return { raw, numeric: null };

    // mínimo inteiro: 1
    if (numeric < 1) return { raw: '1', numeric: 1 };

    // estoque <= 0 → liberdade total (max = 999)
    if (Number(qtProdutoDisponivel) <= 0) {
        if (numeric > 999) return { raw: '999', numeric: 999 };
        return { raw, numeric };
    }

    // estoque > 0 → limitar ao estoque
    if (numeric > qtDisponivel) {
        return { raw: String(qtDisponivel), numeric: qtDisponivel };
    }

    return { raw, numeric };
}

export default {
    paginacao, dateFormat, somenteNumeros, maxLenght, mascaraValor,
    mascaraPorcentagem, mascaraCpfCnpj, mascaraTelefones, mascaraCep, mascaraDDD, mascaraNbm, mascaraNCm,
    validarEmail, mascaraHorario, formataValorPtBr, validadorCpfCnpj, gerarBotoes, tirarAcentos, sanitizeQuantidade
}